module.exports = __webpack_public_path__ + "img/step2.abc47097.png";